import React from 'react';
import './GuestGuide.css';
import { useLanguage } from '../contexts/LanguageContext';
import SeparatorLine from '../assets/photos/sep3.png';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const Icon = ({ children }) => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    {children}
  </svg>
);

const ICONS = {
  trips: (
    <Icon>
      <path {...stroke} d="M4 24.5l7.2-11.4L16 19l4.6-7.4L28 24.5" />
      <path {...stroke} d="M3 24.5h26" />
      <path {...stroke} d="M8.5 24.5c2.2-2.4 4-4.2 6.2-6.2" strokeDasharray="1.4 2.2" />
      <circle cx="23.2" cy="7.4" r="1.7" fill="currentColor" stroke="none" />
    </Icon>
  ),
  food: (
    <Icon>
      <path {...stroke} d="M7.5 15.5h17" />
      <path {...stroke} d="M10 15.5c.15-4.6 2.6-8 6-8s5.85 3.4 6 8" />
      <circle cx="16" cy="6.2" r="1.15" fill="currentColor" stroke="none" />
      <path {...stroke} d="M16 7.4v1.6" />
      <ellipse {...stroke} cx="16" cy="21.2" rx="9.2" ry="2.3" />
    </Icon>
  ),
  bars: (
    <Icon>
      <path {...stroke} d="M8 9h11v8.4a3.6 3.6 0 0 1-3.6 3.6h-3.8A3.6 3.6 0 0 1 8 17.4V9z" />
      <path {...stroke} d="M19 11.4h2.6a2.3 2.3 0 0 1 0 4.6H19" />
      <path {...stroke} d="M8.6 9c.4-2.2 2.2-3.6 5-3.6s4.6 1.4 5 3.6" />
      <path {...stroke} d="M10.4 6.2c.45.7.45 1.3 0 2M13.6 5.4c.45.7.45 1.3 0 2M16.8 6.2c.45.7.45 1.3 0 2" />
    </Icon>
  ),
  wine: (
    <Icon>
      <path {...stroke} d="M9.5 5.5h11L19 14.2a4.2 4.2 0 0 1-8 0L9.5 5.5z" />
      <path {...stroke} d="M15 18.4V23.2" />
      <path {...stroke} d="M11.2 25h7.6" />
      <path {...stroke} d="M12.2 5.5c.6 3.2 1.6 5.4 2.8 6.6" />
    </Icon>
  ),
  shops: (
    <Icon>
      <path {...stroke} d="M7 12h18l-1.5 11.2a2 2 0 0 1-2 1.7H10.5a2 2 0 0 1-2-1.7L7 12z" />
      <path {...stroke} d="M12 12V9.4A4 4 0 0 1 16 5.4 4 4 0 0 1 20 9.4V12" />
      <path {...stroke} d="M12.5 17.2h7" />
    </Icon>
  ),
  spa: (
    <Icon>
      <ellipse {...stroke} cx="16" cy="22.4" rx="8.6" ry="2.15" />
      <ellipse {...stroke} cx="16" cy="17.6" rx="6.2" ry="1.85" />
      <ellipse {...stroke} cx="16" cy="13.4" rx="4" ry="1.45" />
      <path {...stroke} d="M16 9.2c2.1 1.5 2.6 3.2.4 4.2 1.8-.6 2.6-2 2.2-3.4-1 .9-1.8 1.2-2.6.8" />
    </Icon>
  ),
  extra: (
    <Icon>
      <ellipse {...stroke} cx="11.2" cy="11.2" rx="4.4" ry="5.5" />
      <ellipse {...stroke} cx="20.2" cy="12.6" rx="3.5" ry="4.4" />
      <path {...stroke} d="M9.4 16.2c.7 1.3 1.6 1.8 1.8 3" />
      <path {...stroke} d="M18.6 16.6c.6 1.1 1.3 1.5 1.4 2.6" />
      <path {...stroke} d="M11.2 19.2c2.2 1.6 6.2 1.5 8.8-.2" />
      <path d="M24.6 6.4l.55 1.4 1.4.55-1.4.55-.55 1.4-.55-1.4-1.4-.55 1.4-.55z" fill="currentColor" />
    </Icon>
  ),
};

const GuestGuide = () => {
  const { t } = useLanguage();
  const items = t('guestGuide.items');

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <section className="guest-guide" id="guest-guide">
      <img src={SeparatorLine} className="separator" alt="" />
      <h3>{t('guestGuide.title')}</h3>
      <p className="guest-guide-intro">{t('guestGuide.intro')}</p>
      <div className="guest-guide-grid">
        {items.map((item) => (
          <a className="guest-guide-card" key={item.hash} href={`/guide/#${item.hash}`}>
            <span className="guest-guide-icon">{ICONS[item.hash]}</span>
            <span className="guest-guide-copy">
              <span className="guest-guide-kicker">{item.kicker}</span>
              <strong>{item.title}</strong>
              <span className="guest-guide-text">{item.text}</span>
            </span>
          </a>
        ))}
      </div>
      <a className="guest-guide-cta" href="/guide/">{t('guestGuide.open')}</a>
    </section>
  );
};

export default GuestGuide;
